export enum IntegrationStatus {
  InstitutionNotResponding = 'INSTITUTION_NOT_RESPONDING',
  Error = 'ERROR',
  Healthy = 'HEALTHY',
  PendingExpiration = 'PENDING_EXPIRATION',
  SyncInProgress = 'SYNC_IN_PROGRESS',
  ProductsNotSupported = 'PRODUCTS_NOT_SUPPORTED',
  InstitutionNoLongerSupported = 'INSTITUTION_NO_LONGER_SUPPORTED',
}
